import { motion } from "framer-motion";
import { useLang } from "@/lib/LangContext";

export default function StatsStrip() {
  const { services: SERVICES, cities: CITIES, lang } = useLang();
  const stats = [
    { n: `${CITIES.length}+`, label: lang === "fr" ? "Communautés N.-B. couvertes" : "NB Communities Covered" },
    { n: String(SERVICES.length), label: lang === "fr" ? "Services livrés" : "Services Delivered" },
    { n: "4h", label: lang === "fr" ? "Déploiement N.-B." : "Deploy Anywhere in NB" },
    { n: "17+", label: lang === "fr" ? "Années depuis 2008" : "Years Since 2008" },
  ];

  return (
    <section
      data-testid="stats-strip"
      className="border-t border-border bg-background"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-2 md:grid-cols-4 border-t border-l border-border">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.7,
                delay: i * 0.08,
                ease: [0.76, 0, 0.24, 1],
              }}
              className="border-r border-b border-border p-8 md:p-10"
            >
              <div
                className="font-serif font-light leading-none tracking-tighter"
                style={{ fontSize: "clamp(3rem, 7vw, 6rem)" }}
              >
                {s.n}
              </div>
              <div className="font-mono text-[10px] md:text-xs tracking-[0.25em] uppercase text-muted-foreground mt-4">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
